document.querySelectorAll('.custom-checkbox input').forEach(function (el) {
  el.addEventListener('change', function () {
    let cont = el.closest('.custom-checkbox-container');
    if (cont.classList.contains('checked')) {
      cont.classList.remove('checked')
    } else {
      cont.classList.add('checked')
    }
  });
});
document.querySelectorAll('.number-field input').forEach(function (el) {
  el.addEventListener('keydown', function (e) {
    validateNumField(e);
  });
  el.addEventListener('input', function (e) {
    validateNumField(e);
  });
});
document.querySelectorAll('.upload-field input').forEach(function (el) {
  el.addEventListener('change', function (e) {
    e.target.closest('.upload-field').querySelector('.file-text').textContent = this.files[0].name;
  });
});
document.querySelectorAll('.upload-artwork select').forEach(function (el) {
  el.addEventListener('change', function (e) {
    toggleB2BUploadFields(el);
  });
});

function toggleB2BUploadFields(el) {
  let val = el.value;
  let fields = el.closest('.upload-artwork').querySelector('.options');
  let info = el.closest('.upload-artwork').querySelector('.info');

  if (val.toLowerCase() == 'upload') {
    if (info) info.classList.remove('hidden');
    if (fields) fields.classList.remove('hidden');
  } else {
    if (info) info.classList.add('hidden');
    if (fields) fields.classList.add('hidden');
  }
}

function validateNumField(event) {
  if (parseInt(event.target.value) > 9999) {
    event.target.value = 9999;
    event.preventDefault();
  }
  if ((event.code == 'ArrowLeft') || (event.code == 'ArrowRight') ||
    (event.code == 'ArrowUp') || (event.code == 'ArrowDown') ||
    (event.code == 'Delete') || (event.code == 'Backspace') ||
    (event.code == 'Tab')) {
    return;
  } else if (typeof event.key != "undefined" && event.key.search(/\d/) == -1) {
    event.preventDefault();
  }
}

function getBrowserName() {
  let name = '';
  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
    name = 'opera';
  } else if (navigator.userAgent.indexOf("Edg") != -1) {
    name = 'edge';
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    name = 'chrome';
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    name = 'safari';
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    name = 'firefox';
  } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
  {
    name = 'ie';
  } else {
    name = 'unknown';
  }

  document.querySelector('body').classList.add('browser-' + name);
}

let b2bURLBase = 'https://shopifyapp.fpsapparel.com';
if (window.location.href.includes('dev-new-fpsapparel')) {
  b2bURLBase = 'https://dev.shopifyapp.fpsapparel.com';
}

let B2BStorefront = {
  api: {
    url_draft_orders: b2bURLBase + '/api/storefront/draft_orders',
    url_upload: b2bURLBase + '/api/storefront/upload',
    url_prices: b2bURLBase + '/api/storefront/products/pricing',
    token: window.b2b_jwt_token,
    maxTries: 6,
  },
  tries: 0,
  running: false,
  files: [],
  numberOfFiles: 0,
  uploading: 0,
  listPrices: {},
  b2bPrices: {},
  allB2bPrices: {},
  optionsPrices: {},
  randomSamplePrices: {},
  gettingPrices: 0,
  gettingOptionsPrices: 0,
  gettingRandomSamplePrices: 0,
  updatingCartItems: 0,
  additionalDecorationLabel: null,
  timer: null,
  total: 0,
  totalWithDecoration: 0,
  totalEach: 0,
  currentColor: null,
  activeVariants: [],
  productOptions: null,
  variantsJSON: [],
  sampleVariantsJSON: [],
  colorIndexString: 'option1',
  sizeIndexString: 'option2',

  init: function () {
    if (this.running) return;
    let _this = this;
    if (this.api.token == null) {
      this.getJWTToken();
    }

    if (document.querySelector('[data-product-options]') != null) {
      this.productOptions = document.querySelector('[data-product-options]').dataset.productOptions.split(',');

      // get correct color and size indexes
      let colorIndex = 1;
      let sizeIndex = 2;

      this.productOptions.forEach((option, index) => {
        if (option.toLowerCase() === 'color') {
          colorIndex = index + 1;
        } else if (option.toLowerCase() === 'size') {
          sizeIndex = index + 1;
        }
      });

      this.colorIndexString = 'option' + colorIndex;
      this.sizeIndexString = 'option' + sizeIndex;
    }
    //if (document.querySelector('[data-variants-json]') != null) {
    if (typeof window.variants_json != "undefined") {
      //this.variantsJSON = JSON.parse(document.querySelector('[data-variants-json]').dataset.variantsJson);
      this.variantsJSON = window.variants_json;
    }
    if (document.querySelector('[data-sample-variants-json]') != null) {
      this.sampleVariantsJSON = JSON.parse(document.querySelector('[data-sample-variants-json]').dataset.sampleVariantsJson);
    }

    this.setupImprintColors();
    this.calculateTotal.bind(_this)();

    $(document).one('DOMSubtreeModified', ".ajaxcart__container", function () {
      _this.setupAjaxCart();
    });

    document.addEventListener('ajaxcart:updated', (e) => {
      _this.setupAjaxCart();
    });

    document.addEventListener('ajaxcart:changed', (e) => {
      _this.updateCartItems(e.detail.cart);
    });

    if (document.querySelector('[data-custom-prices]') != null) {
      this.listPrices = JSON.parse(document.querySelector('[data-custom-prices]').dataset.customPrices);
      this.updatePriceRange();
    }

    if (document.querySelector('.b2b-prices') != null) {
      let _this = this;
      let productId = document.querySelector('.b2b-prices').dataset.productId;
      let sampleProductId = document.querySelector('.b2b-prices').dataset.sampleProductId;
      if (productId.length > 0) productId = parseInt(productId);
      this.getB2BPrices(productId, 1, _this.calculateTotal.bind(_this));
      if (document.querySelector('[name="sample-product"]')) {
        this.getrandomSamplePrices(sampleProductId, 1, _this.calculateTotal.bind(_this));
      }
      this.initNetPricesTable(productId);
      this.setupSizes();
    }

    jQuery(document).on('click', '.b2b-customer .cart__checkout, .b2b-customer .ajaxcart__checkout', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      fetch("/cart.js")
        .then(response => response.json())
        .then(data => {
          _this.submitDraftOrder(data, $(this)[0])
        }).catch(error => {
        console.log(error)
      });
    });

    document.querySelectorAll('.b2b-product-add').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        _this.files = [];
        _this.uploading = 0;
        _this.prepDataAndAddToCart(false, el);
      });
    });
    document.querySelectorAll('.b2b-product-add-random-sample').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        _this.files = [];
        _this.uploading = 0;
        _this.prepDataAndAddToCart(true, el);
      });
    });

    document.querySelectorAll('product-interactive-options .product-form__swatch__item--color').forEach(function (el) {
      el.addEventListener('click', function (e) {
        _this.currentColor = e.target.getAttribute('value');

        document.querySelectorAll('.product-form__swatch__item').forEach(function (item) {
          let input = item.querySelector('input');
          input.checked = false;
          input.removeAttribute('checked');
        });

        let input = el.closest('.product-form__swatch__item').querySelector('input');
        input.checked = true;
        input.setAttribute('checked', '');

        _this.calculateTotal.bind(_this)();
        _this.setupSizes();
        _this.getActiveVariants();
        _this.updateImage();
      });
    });

    document.querySelectorAll('.decoration-option select').forEach(function (el) {
      el.addEventListener('change', function (e) {
        let selected = e.target.options[e.target.selectedIndex];
        _this.updateColorOptions(selected);
        _this.setupImprintColors(selected, true);
        _this.calculateTotal.bind(_this)();
      });
    });

    document.querySelectorAll('.js-product-single-actions input[name="quantity"]').forEach(function (el) {
      el.addEventListener('keyup', function (e) {
        clearTimeout(_this.timer);
        if (el.value) {
          _this.timer = setTimeout(function () {
            _this.calculateTotal.bind(_this)()
          }, 1000);
        }
      });
    });

    document.querySelectorAll('product-interactive-options input[type="number"]').forEach(function (el) {
      el.addEventListener('keyup', function (e) {
        clearTimeout(_this.timer);
        _this.timer = setTimeout(function () {
          _this.validateNumFieldMin(e);
          validateNumField(e);
          _this.calculateTotal.bind(_this)();

          if (el.closest('.b2b-sizes')) {
            _this.updateTotalQty();
          }
        }, 1000);
      });
      el.addEventListener('input', function (e) {
        clearTimeout(_this.timer);
        _this.timer = setTimeout(function () {
          _this.validateNumFieldMin(e);
          validateNumField(e);
          _this.calculateTotal.bind(_this)();

          if (el.closest('.b2b-sizes')) {
            _this.updateTotalQty();
          }
        }, 1000);
      });
    });

    document.querySelectorAll('.customization-field.decoration-locations .options .custom-radio input').forEach(function (el) {
      el.addEventListener('change', function (e) {
        _this.setupImprintColors();
      });
    });

    document.querySelectorAll('.imprint-colors input').forEach(function (el) {
      el.addEventListener('change', function (e) {
        _this.calculateTotal.bind(_this)();
      });
    });

    document.querySelectorAll('.random-sample-confirm .remodal-close,.random-sample-confirm .remodal-cancel').forEach(function (el) {
      el.addEventListener('click', function (e) {
        _this.closeRandomSampleConfirm();
      });
    });

    document.querySelectorAll('.random-sample-confirm .remodal-confirm').forEach(function (el) {
      el.addEventListener('click', function (e) {
        let form = document.querySelector('.js-product-single-actions form');

        _this.closeRandomSampleConfirm();
        _this.addSampleProductToCart(form.querySelector('[name="sample-product"]').dataset.id);
      });
    });

    document.querySelectorAll('[name="sample-product"]').forEach(function (el) {
      el.addEventListener('change', function () {
        let target = document.querySelector('.b2b-product-customization');
        if (el.checked) {
          target.classList.add('hidden');
        } else {
          target.classList.remove('hidden');
        }
        _this.updateSamplePrices();
      });

    });
    document.querySelectorAll('.product-single .view-list-price').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        let listPrice = el.closest('.b2b-prices').querySelector('.custom-prices-container.list-price');
        let netPrice = el.closest('.b2b-prices').querySelector('.custom-prices-container.net-price');
        if (listPrice != null && !listPrice.classList.contains('hidden')) {
          listPrice.classList.add('hidden');
        } else {
          if (listPrice != null) listPrice.classList.remove('hidden');
          if (netPrice != null) netPrice.classList.add('hidden');
        }
      });
    });
    document.querySelectorAll('.product-single .view-net-price').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        let listPrice = el.closest('.b2b-prices').querySelector('.custom-prices-container.list-price');
        let netPrice = el.closest('.b2b-prices').querySelector('.custom-prices-container.net-price');
        if (netPrice != null && !netPrice.classList.contains('hidden')) {
          netPrice.classList.add('hidden');
        } else {
          if (netPrice != null) netPrice.classList.remove('hidden');
          if (listPrice != null) listPrice.classList.add('hidden');
        }
      });
    });
  },

  updateTotalQty: function () {
    let activeVariants = this.activeVariants;
    let totalQty = 0;

    activeVariants.forEach(item => {
      totalQty += item.quantity;
    });

    let qtySumField = document.querySelector('.b2b-sizes .qty-sum-field');
    qtySumField.value = totalQty;
  },

  openRandomSampleConfirm: function () {
    let cont = document.querySelector('.random-sample-confirm-container');
    cont.classList.add('active');
  },

  closeRandomSampleConfirm: function () {
    let cont = document.querySelector('.random-sample-confirm-container');
    cont.classList.remove('active');
  },

  updateColorOptions: function (option) {
    //let defaultDecoration = option.dataset.defaultDecoration === 'true';
    let label = option.dataset.decorationName;
    let locations = document.querySelector('.customization-field.decoration-locations');
    let colors = document.querySelector('.customization-field.imprint-colors');

    if (typeof label == "undefined") return;

    let label1 = document.querySelector('.imprint-colors .title .colors-label');

    colors.classList.remove('hidden');
    label1.innerText = label;
    //}
  },

  updateCartItems: function (cart) {
    let _this = this;
    let itemGroups = {};

    cart.items.forEach((item) => {
      let uniqueId = item.properties['_unique_id'];
      if (typeof uniqueId == "undefined" || !uniqueId) {

      } else {
        if (typeof itemGroups[uniqueId] == "undefined") {
          itemGroups[uniqueId] = [];
        }
        itemGroups[uniqueId].push(item);
      }
    });

    for (const [uniqueId, items] of Object.entries(itemGroups)) {
      let combinedQty = 0;
      let decorationItem = null;
      let productId = null

      items.forEach((item) => {
        let isDecoration = false;

        for (const [key, value] of Object.entries(item.properties)) {
          if (key == '_is_decoration') {
            decorationItem = item;
            isDecoration = true;
          }
        }

        if (!isDecoration) {
          combinedQty += item.quantity;

          if(!productId) {
            productId = item.product_id;
          }
        }

      });

      if (_this.gettingPrices > 0 || _this.gettingOptionsPrices > 0) {
        setTimeout(function() {
          _this.updateCartItems.bind(_this)(cart)
        }, 500);
        return;
      }
      else {
        if (typeof _this.allB2bPrices[productId] == "undefined") {
          _this.getB2BPrices(productId, combinedQty, () => {
            _this.updateCartItems.bind(_this)(cart);
          }, false);

          return;
        }

        if (decorationItem && (!_this.optionsPrices.hasOwnProperty(decorationItem.product_id) || !_this.optionsPrices[decorationItem.product_id].hasOwnProperty([combinedQty]))) {
          _this.getOptionsPrices(decorationItem.product_id, combinedQty, () => {
            _this.updateCartItems.bind(_this)(cart);
          });

          return;
        }
      }

      let updates = []

      items.forEach((item) => {
        let isDecoration = false;
        for (const [key, value] of Object.entries(item.properties)) {
          if (key == '_is_decoration') {
            isDecoration = true;
          }
        }

        let _productId = item.product_id;

        if (typeof item.properties['_totalQty'] != "undefined") {
          if (combinedQty != parseInt(item.properties['_totalQty'])) {
            let _data = {
              'id': item.key,
              'properties': item.properties
            }

            _data.properties['_totalQty'] = combinedQty;

            if(isDecoration) {
              _data['quantity'] = combinedQty;
            }
            else {
              _data['quantity'] = item.quantity;
            }

            let tier = null;
            if(typeof _this.allB2bPrices[_productId] != "undefined") {
              for(const [qty, prices] of Object.entries(_this.allB2bPrices[_productId])) {
                if(combinedQty > qty || combinedQty == qty) tier = qty;
              }
            }
            else if(typeof _this.optionsPrices[_productId] != "undefined") {
              for(const [qty, prices] of Object.entries(_this.optionsPrices[_productId])) {
                if(combinedQty > qty || combinedQty == qty) tier = qty;
              }
            }

            if(tier) {
              if(isDecoration) _data.properties['_totalEach'] = _this.optionsPrices[_productId][tier].variants[item.id].amount;
              else _data.properties['_totalEach'] = _this.allB2bPrices[_productId][tier].variants[item.id].amount;

              updates.push(_data)

            }
          }
        }
      });

      updates.forEach((update) => {
        _this.changeCartItems.bind(_this)(update, () => {
          _this.setupAjaxCart();
        });
      })
    }

  },

  changeCartItems: function (data, callback=null) {
    let _this = this;

    if(_this.updatingCartItems > 0) {
      setTimeout(()=> {
        _this.changeCartItems.bind(_this)(data, callback);
      }, 500);
      return;
    }

    _this.updatingCartItems++;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(_data => {
        _this.updatingCartItems--;
        if (typeof callback == "function") {
          return callback.bind(_this)(_data);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  },

  setupAjaxCart: function () {
    let total = 0;
    fetch("/cart.js")
      .then(response => response.json())
      .then(data => {
        data.items.forEach((item, key) => {
          let itemTotal = parseFloat(item.properties._totalEach) * parseInt(item.quantity);
          if (itemTotal) {
            let target = document.querySelector('.ajaxcart__row[data-line="' + (key + 1) + '"] .ajaxcart-item__price .money');
            if (target) target.innerText = '$' + itemTotal;
            total += itemTotal;
          }
          if (typeof item.properties._is_decoration != "undefined") {
            let itemTotal = parseFloat(item.properties._totalEach) * parseInt(item.quantity);
            let target = document.querySelector('.ajaxcart__row[data-line="' + (key + 1) + '"]');
            if (target) {
              target.querySelector('.ajaxcart__qty input').value = item.quantity;
              target.querySelector('.ajaxcart-item__price .money').innerText = '$' + itemTotal.toFixed(2);
              //total += itemTotal;
              target.classList.add('is-decoration');
              target.querySelector('input').setAttribute('disabled', 'disabled');
              target.querySelector('.ajaxcart__qty--minus').setAttribute('disabled', 'disabled');
              target.querySelector('.ajaxcart__qty--plus').setAttribute('disabled', 'disabled');
            }
          }
        });

        if (total < 1) total = data.total_price / 100;
        total = total.toFixed(2);

        let targetFooter = document.querySelector('.ajaxcart__footer-total .money');
        if (targetFooter) targetFooter.innerText = '$' + total;

      }).catch(error => {
      console.log(error)
    });
  },

  setupImprintColors: function (decoration = null, decorationChanged = false) {
    let _this = this;

    if (decoration == null) {
      if (document.querySelector('.decoration-option select') != null) {
        let selecteEl = document.querySelector('.decoration-option select');
        decoration = selecteEl.options[selecteEl.selectedIndex];
      }
    }

    if (!decoration) return;

    let imprintColors = document.querySelector('.imprint-colors');
    let decorationLocations = document.querySelector('.decoration-locations');
    let artwork = document.querySelector('.upload-artwork.additional-decorations');

    let handle = decoration.dataset.handle;

    let targetColor = imprintColors.querySelector('.options[data-handle="' + handle + '"]');
    let targetLocation = decorationLocations.querySelector('.options[data-handle="' + handle + '"]');
    let targetArtwork = artwork.querySelector('.options[data-handle="' + handle + '"]');

    if (targetColor || targetLocation || targetArtwork) {
      imprintColors.querySelectorAll('.options').forEach(el => {
        el.classList.add('hidden');
      });
      decorationLocations.querySelectorAll('.options').forEach(el => {
        el.classList.add('hidden');
      });
      artwork.querySelectorAll('.options').forEach(el => {
        el.classList.add('hidden');
      });

      if (targetColor.querySelector('.custom-radio').classList.contains('hidden')) {
        imprintColors.classList.add('hidden');
        decorationLocations.classList.add('hidden');
        targetArtwork.classList.add('hidden');
      } else {
        imprintColors.classList.remove('hidden');
        decorationLocations.classList.remove('hidden');
        artwork.classList.remove('hidden');

        targetColor.classList.remove('hidden');
        targetLocation.classList.remove('hidden');
        targetArtwork.classList.remove('hidden');
      }
    } else {
      imprintColors.classList.add('hidden');
      decorationLocations.classList.add('hidden');
      artwork.classList.add('hidden');
    }

    if (targetLocation && targetArtwork) {

      let locations = targetLocation.querySelectorAll('.custom-radio');
      //let colors = document.querySelector('.customization-field.imprint-colors .options');

      if (decorationChanged) {
        locations[0].querySelector('input').removeAttribute('checked');
        $(locations[0]).find('input').prop('checked', 'checked');
      }

      this.numberOfFiles = 0;
      locations.forEach(function (el) {
        if (el.querySelector('input').checked) {
          let loc = el.dataset.location;
          //colors.querySelector('[data-location="' + loc + '"]').classList.remove('hidden');
          targetArtwork.querySelector('[data-location="' + loc + '"]').classList.remove('hidden');
          _this.numberOfFiles++;
        } else {
          let loc = el.dataset.location;
          //colors.querySelector('[data-location="' + loc + '"]').classList.add('hidden');
          targetArtwork.querySelector('[data-location="' + loc + '"]').classList.add('hidden');
        }
      });
    }
  },

  validateNumFieldMin: function (event) {
    let el = event.target;
    if (parseInt(el.value) > 0 && parseInt(el.value) < parseInt(el.getAttribute('min'))) {
      el.value = el.getAttribute('min');
    }
  },

  updateImage: function () {
    let targetImage = document.querySelector('.media-gallery__thumbs .thumbnail-list__item[data-color="' + this.currentColor + '"] button');
    if (targetImage != null) targetImage.dispatchEvent(new Event('click'));
  },

  setupSizes: function () {
    let _this = this;
    if (this.currentColor == null) {
      this.currentColor = document.querySelector('product-interactive-options .product-form__swatch__item--color input:checked').value;
    }

    this.variantsJSON.forEach(variant => {
      if (variant[_this.colorIndexString] == _this.currentColor) {
        let size = variant[_this.sizeIndexString];
        let sizeEl = document.querySelector('.b2b-sizes input[type="number"][data-value="' + size + '"]');
        if (variant.quantity_rule.min != null) {
          sizeEl.setAttribute('min', variant.quantity_rule.min);
        }
        if (variant.quantity_rule.max != null) {
          sizeEl.setAttribute('max', variant.quantity_rule.max);
        }
        if (variant.quantity_rule.increment != null) {
          sizeEl.setAttribute('step', variant.quantity_rule.increment);
        }
      }
    });

    this.setUpPricingTableColors();
  },

  setUpPricingTableColors: function () {
    let _this = this;

    document.querySelectorAll('.custom-prices-table th,.custom-prices-table td').forEach(el => {
      el.classList.remove('hidden');
    });

    document.querySelectorAll('.custom-prices-table th,.custom-prices-table td').forEach(el => {
      if (el.dataset.color != _this.currentColor && !el.classList.contains('qty')) {
        el.classList.add('hidden');
      }
    });
  },

  getrandomSamplePrices: function (id, qty, callback = null) {
    let _this = this;
    let url = this.api.url_prices;

    qty = parseInt(qty);
    if (isNaN(qty)) qty = 1;

    if (id == null || id.length < 1 || isNaN(id) || isNaN(qty)) {
      if (typeof callback == 'function') {
        return callback.bind(_this)();
      }
      return;
    }

    let data = {
      'product_id': parseInt(id),
      'quantity': qty
    }

    $.ajax(url, {
      type: 'POST',
      data: data,
      dataType: 'json',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', `Bearer ${_this.api.token}`);
        xhr.setRequestHeader('Accept', 'application/json');
        _this.gettingRandomSamplePrices++;
      },
      success: function (_data) {
        _this.randomSamplePrices[qty] = _data;
        _this.gettingRandomSamplePrices--;
        _this.tries = 0;
        if (_this.gettingRandomSamplePrices < 0) _this.gettingRandomSamplePrices = 0;
        _this.updateSamplePrices();
        if (typeof callback == 'function') {
          return callback.bind(_this)();
        }
      },
      error: function (xhr, status, error) {
        if (_this.tries >= _this.api.maxTries) {
          _this.running = false;
          throw error;
        }

        if (xhr.status !== 401) {
          _this.running = false;
          throw error;
        } else {
          _this.getJWTToken(_this.getrandomSamplePrices.bind(_this)(id, qty, callback));
        }

      }
    });
  },

  getB2BPrices: function (id, qty, callback = null, updatePrices = true) {
    let _this = this;
    let url = _this.api.url_prices;
    qty = parseInt(qty);
    if (isNaN(qty)) qty = 1;

    if (parseInt(qty) < 1) {
      if (typeof callback == 'function') {
        return callback.bind(_this)();
      }
      return;
    }

    let data = {
      'product_id': parseInt(id),
      'quantity': qty
    }

    $.ajax(url, {
      type: 'POST',
      data: data,
      dataType: 'json',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', `Bearer ${_this.api.token}`);
        xhr.setRequestHeader('Accept', 'application/json');
        _this.gettingPrices++;
      },
      success: function (_data) {
        _this.gettingPrices--;
        if (_this.gettingPrices < 0) _this.gettingPrices = 0;
        _this.tries = 0;

        if (updatePrices) {
          _this.b2bPrices[qty] = _data;
        }
        if(typeof _this.allB2bPrices[id] == "undefined") _this.allB2bPrices[id] = {};
        _this.allB2bPrices[id][qty] = _data;

        if (typeof callback == 'function') {
          return callback.bind(_this)(_data);
        }
      },
      error: function (xhr, status, error) {
        if (_this.tries >= _this.api.maxTries) {
          _this.running = false;
          throw error;
        }

        if (xhr.status !== 401) {
          _this.running = false;
          throw error;
        } else {
          _this.getJWTToken(_this.getB2BPrices.bind(_this)(id, qty, callback));
        }

      }
    });
  },

  getOptionsPrices: function (prodId = null, qty = 1, callback = null) {
    let _this = this;
    let url = _this.api.url_prices;
    qty = parseInt(qty);
    if (isNaN(qty)) qty = 1;

    if (prodId != null && qty > 0) {
      let data = {
        'product_id': prodId,
        'quantity': qty
      }

      $.ajax(url, {
        type: 'POST',
        data: data,
        dataType: 'json',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${_this.api.token}`);
          xhr.setRequestHeader('Accept', 'application/json');
          _this.gettingOptionsPrices++;
        },
        success: function (_data) {
          if (typeof _this.optionsPrices[prodId] == "undefined") _this.optionsPrices[prodId] = {};
          _this.optionsPrices[prodId][qty] = _data;
          _this.gettingOptionsPrices--;
          _this.tries = 0;
          if (_this.gettingOptionsPrices < 0) _this.gettingOptionsPrices = 0;
          if (typeof callback == 'function') {
            return callback.bind(_this)(_data);
          }
        },
        error: function (xhr, status, error) {
          if (_this.tries >= _this.api.maxTries) {
            _this.running = false;
            throw error;
          }

          if (xhr.status !== 401) {
            _this.running = false;
            throw error;
          } else {
            _this.getJWTToken(_this.getOptionsPrices.bind(_this)(prodId, qty, callback));
          }

        }
      });
    } else if (qty > 0) {
      let options = document.querySelectorAll('.b2b-product-customization .decoration-option select option');

      if (options.length > 0) {
        options.forEach(option => {
          if (option.value != '') {
            let prodId = option.dataset.productId;
            let data = {
              'product_id': prodId,
              'quantity': qty
            }

            $.ajax(url, {
              type: 'POST',
              data: data,
              dataType: 'json',
              beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', `Bearer ${_this.api.token}`);
                xhr.setRequestHeader('Accept', 'application/json');
                _this.gettingOptionsPrices++;
              },
              success: function (_data) {
                if (typeof _this.optionsPrices[prodId] == "undefined") _this.optionsPrices[prodId] = {};
                _this.optionsPrices[prodId][qty] = _data;
                _this.gettingOptionsPrices--;
                _this.tries = 0;
                if (_this.gettingOptionsPrices < 0) _this.gettingOptionsPrices = 0;
                if (typeof callback == 'function') {
                  return callback.bind(_this)();
                }
              },
              error: function (xhr, status, error) {
                if (_this.tries >= _this.api.maxTries) {
                  _ = false;
                  throw error;
                }

                if (xhr.status !== 401) {
                  _this.running = false;
                  throw error;
                } else {
                  _this.getJWTToken(_this.getOptionsPrices.bind(_this)(prodId, qty, callback));
                }

              }
            });
          }
        });
      } else if (typeof callback == 'function') {
        return callback.bind(_this)();
      }
    } else if (typeof callback == 'function') {
      return callback.bind(_this)();
    }

  },

  initNetPricesTable: function (productId = null) {
    let _this = this;
    let cont = document.querySelector('.js-product-single-actions');
    let priceBreaks = JSON.parse(cont.querySelector('[data-price-breaks]').dataset.priceBreaks);
    if (productId == null) productId = document.querySelector('.b2b-prices').dataset.productId;

    if (priceBreaks == null) {
      cont.querySelector('.custom-prices-container.net-price').classList.add('hidden');
      cont.querySelector('.view-net-price').classList.add('hidden');
      return;
    }

    let prices = {};

    if (_this.gettingPrices > 0) {
      setTimeout(function () {
        _this.initNetPricesTable(productId);
      }, 250);
    } else {

      let hasAllPrices = true;
      priceBreaks.forEach(tier => {
        if (!_this.b2bPrices.hasOwnProperty(tier)) {
          hasAllPrices = false;
          _this.getB2BPrices(productId, tier, _this.calculateTotal.bind(_this));
        }
      });

      if (hasAllPrices) {
        _this.buildNetPricesTable();
      } else {
        setTimeout(function () {
          _this.initNetPricesTable(productId);
        }, 250);
      }

    }

  },

  buildNetPricesTable: function () {
    let _this = this;
    let cont = document.querySelector('.js-product-single-actions');
    let priceBreaks = JSON.parse(cont.querySelector('[data-price-breaks]').dataset.priceBreaks);
    let tableCont = document.querySelector('.custom-prices-container.net-price .table-container');

    if (this.b2bPrices == null) {
      document.querySelector('.product-single .view-net-price').classList.add('hidden');
      document.querySelector('.product-single .custom-prices-container.net-price').classList.add('hidden');
      return;
    }

    let table = document.createElement('table');
    table.classList.add('custom-prices-table');

    let headerRow = document.createElement('tr');
    let th0 = document.createElement('th');
    th0.innerText = 'Qty';
    th0.classList.add('qty');
    headerRow.appendChild(th0);

    this.variantsJSON.forEach(variant => {
      let th = document.createElement('th');
      th.innerText = variant.title;
      th.dataset.color = variant[_this.colorIndexString];
      headerRow.appendChild(th);
    });
    table.appendChild(headerRow);

    for (const [key, value] of Object.entries(this.b2bPrices)) {
      if (priceBreaks.includes(parseInt(key))) {
        let row = document.createElement('tr');
        let td0 = document.createElement('td');
        td0.innerText = key;
        td0.classList.add('qty');
        row.appendChild(td0);

        _this.variantsJSON.forEach(variant => {
          let td = document.createElement('td');
          td.innerText = '$' + parseFloat(value.variants[variant.id].amount).toFixed(2);
          td.dataset.color = variant[_this.colorIndexString];
          row.appendChild(td);
        });

        table.appendChild(row);
      }
    }

    tableCont.appendChild(table);
    this.setUpPricingTableColors();
  },

  prepDataAndAddToCart: function (sample = false, btn = null) {
    this.running = true;
    let _this = this;
    let cont = document.querySelector('.js-product-single-actions');
    let form = cont.querySelector('form');

    let uniqueId = Date.now();

    if (sample) {
      _this.openRandomSampleConfirm();
      return;
    }

    if (!this.validateForm(form)) return;
    if (cont.querySelector('[data-variants-json]') == null) return;

    if (btn != null) {
      btn.classList.add('loading');
    }

    // get active variant IDs ant quantities
    let activeVariants = this.activeVariants;

    let formData = new FormData(form);
    let properties = {};
    let files = {};

    properties['_customized_product'] = true;
    properties['_unique_id'] = uniqueId;

    let totalQty = 0;

    if (typeof activeVariants != "undefined" && activeVariants.length > 0) {
      activeVariants.forEach(variant => {
        totalQty += variant.quantity;
      });
    }

    for (let [key, value] of formData) {
      if (key.includes('properties') && !key.includes('Artwork -')) {
        let name = key.replace('properties[', '').replace(']', '');
        properties[name] = value;
      }
    }

    let decoration = null;
    let decorationVarId = null;

    let decorationOptionSelect = cont.querySelector('.decoration-option select');
    if (decorationOptionSelect) {
      decoration = decorationOptionSelect.options[decorationOptionSelect.selectedIndex];
    }
    if (decoration && decoration.value.length > 0) {
      let handle = decoration.dataset.handle;
      let imprintColorsName = cont.querySelector('.imprint-colors [data-handle="' + handle + '"] input').getAttribute('name');

      if (cont.querySelector('[data-handle="' + handle + '"] [name="' + imprintColorsName + '"]:checked')) {
        let _decorationVarId = cont.querySelector('[data-handle="' + handle + '"] [name="' + imprintColorsName + '"]:checked').value;
        decorationVarId = _decorationVarId.split('|')[1].replace(' ', '');
      }
    }

    if (formData.get('properties[Decoration Option]') && formData.get('properties[Decoration Option]').length > 0 && formData.getAll('properties[Decoration locations]').length > 0) {
      properties['Decoration locations'] = formData.getAll('properties[Decoration locations]');
      let decorationOptionHandle = formData.get('properties[Decoration Option]').split('|')[0].replace(' ', '');
      let imprintColorsTarget = formData.get('imprint_colors[' + decorationOptionHandle + ']');
      let imprintColorsLabel = document.querySelector('.imprint-colors [data-handle="' + decorationOptionHandle + '"]').dataset.label;
      properties[imprintColorsLabel] = imprintColorsTarget;
      _this.additionalDecorationLabel = imprintColorsLabel;
    } else {
      if (typeof properties['Decoration Option'] != "undefined") delete properties['Decoration Option'];
      if (typeof properties['Decoration locations'] != "undefined") delete properties['Decoration locations'];
      if (typeof properties['Imprint Colors'] != "undefined") delete properties['Imprint Colors'];
      if (typeof properties['Artwork Files'] != "undefined") delete properties['Artwork Files'];

      for (let [key, value] of Object.entries(properties)) {
        if (key.includes('Number of') && !key.includes('Artwork -')) {

        }
      }
    }
    //properties['_total'] = _this.total;
    properties['_totalWithDecoration'] = _this.totalWithDecoration;
    properties['_totalEach'] = _this.totalEach;
    properties['_totalQty'] = totalQty;

    let i = 0;

    if (cont.querySelector('.upload-artwork.default-decoration') != null) {
      this.numberOfFiles++;

      let fieldName = cont.querySelector('.upload-artwork.default-decoration input').getAttribute('name');

      let fileDone = false;
      this.files.forEach(file => {
        if (file.name == fieldName) fileDone = true;
      });

      if (formData.get(fieldName).name.length > 0 && !fileDone) {
        this.upload(formData.get(fieldName), i, fieldName);
        i++;
      }

    }

    if (this.uploading < this.numberOfFiles && this.files.length < this.numberOfFiles && typeof properties['Decoration locations'] != "undefined") {
      properties['Decoration locations'].forEach(loc => {
        let fileDone = false;
        this.files.forEach(file => {
          if (file.name == loc) fileDone = true;
        });
        if (formData.get('properties[Artwork - ' + loc + ']').name.length > 0 && !fileDone) {
          this.upload(formData.get('properties[Artwork - ' + loc + ']'), i, loc);
        }
        i++;
      });
    }

    if (this.uploading > 0 /*&& this.files.length < this.numberOfFiles*/) {
      setTimeout(function () {
        _this.prepDataAndAddToCart(sample, btn);
      }, 1000);
    } else {
      let data = {
        //'shipping_address': JSON.parse(form.dataset.customerAddress),
        //'customer_id': form.dataset.customerId,
        'items': []
      }

      activeVariants.forEach(variant => {
        this.files.forEach(file => {
          files[file.name] = file.url;
        });

        properties['_files'] = files;

        let obj = {
          'id': variant.id,
          'quantity': variant.quantity,
          'properties': properties,
        }

        data.items.push(obj);
      });

      if (decorationVarId) {
        if (decorationOptionSelect != null) {
          let decorationProdId = decorationOptionSelect.options[decorationOptionSelect.selectedIndex].dataset.productId;
          //decorationOriginalPrice = decorationOptionSelect.options[decorationOptionSelect.selectedIndex].dataset.originalPrice;

          if (decorationProdId && decorationVarId && decorationVarId.length > 0) {
            if (totalQty > 0 &&
              typeof _this.optionsPrices[decorationProdId] != "undefined" &&
              typeof _this.optionsPrices[decorationProdId][totalQty] != "undefined"
            ) {
              let decorationOption = _this.optionsPrices[decorationProdId][totalQty].variants[decorationVarId].amount;

              data.items.push({
                'id': parseInt(decorationVarId),
                'quantity': totalQty,
                'properties': {
                  '_is_decoration': true,
                  '_totalEach': decorationOption,
                  '_unique_id': uniqueId,
                  '_totalQty': totalQty
                }
              })
            }

          }
        }

      }

      let errorCont = btn == null ? null : btn.closest('form').querySelector('.b2b-error.response');
      if (errorCont) errorCont.innerText = '';

      $.ajax('/cart/add.js', {
        contentType: 'application/json',
        type: 'POST',
        data: JSON.stringify(data),
        dataType: 'json',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Accept', 'application/json');
        },
        success: function (data) {
          if (btn != null) {
            btn.classList.add('loaded');
            btn.classList.remove('loading');
            setTimeout(function () {
              btn.classList.remove('loaded');
            }, 2000);
          }
          _this.openCartDrawer();
        },
        error: function (xhr, status, error) {

          if (btn != null) {
            btn.classList.remove('loading');
          }

          if (typeof xhr.responseJSON.description != "undefined") {

            let el = document.createElement('div');
            el.classList.add('error-item');
            el.innerText = xhr.responseJSON.description;
            if (errorCont) {
              errorCont.appendChild(el);
              errorCont.classList.remove('hidden');
              setTimeout(() => {
                errorCont.classList.add('hidden');
              }, 5000);
            }

          }
          _this.openCartDrawer();

          setTimeout(function () {
            if (document.querySelector('.ajaxcart__container .ajaxcart__button')) {
              let cartErrorCont = document.querySelector('.ajaxcart__container .ajaxcart__button');
              let contEl = document.createElement('div');
              contEl.classList.add('b2b-error');
              contEl.classList.add('response');

              let errorEl = document.createElement('div');
              errorEl.classList.add('error-item');
              errorEl.innerText = xhr.responseJSON.description;
              if (cartErrorCont) {
                cartErrorCont.parentNode.insertBefore(errorEl, cartErrorCont);
                //cartErrorCont.appendChild(errorEl);
                errorEl.classList.remove('hidden');
                setTimeout(() => {
                  errorEl.classList.add('hidden');
                }, 5000);
              }
            }
          }, 500);

          throw error;
        }
      });


      //this.submitDraftOrder(data);
    }

  },

  calculateTotal: function () {
    let _this = this;
    let cont = document.querySelector('.js-product-single-actions');
    if (!cont || !document.querySelector('.b2b-prices')) return;
    let productId = document.querySelector('.b2b-prices').dataset.productId;
    let sampleProductId = document.querySelector('.b2b-prices').dataset.sampleProductId;
    if (productId.length > 0) productId = parseInt(productId);
    if (sampleProductId.length > 0) sampleProductId = parseInt(sampleProductId);
    let variants = cont.querySelector('product-interactive-options');
    let priceBreaks = JSON.parse(cont.querySelector('[data-price-breaks]').dataset.priceBreaks);
    let decorationEl = cont.querySelector('.decoration-option select');
    let decorationId = null;
    if (decorationEl) {
      decorationId = decorationEl.options[decorationEl.selectedIndex].dataset.productId;
    }
    let randomSample = false;
    let totalQty = 0;
    let minPriceBreak = 0;
    let maxPriceBreak = 0;

    priceBreaks.forEach(priceBreak => {
      if (minPriceBreak < 1 || priceBreak < minPriceBreak) {
        minPriceBreak = priceBreak
      }
      if (maxPriceBreak < 1 || priceBreak > maxPriceBreak) {
        maxPriceBreak = priceBreak
      }
    });

    if (cont.querySelector('[name="sample-product"]') != null) {
      if (cont.querySelector('[name="sample-product"]').checked) {
        randomSample = true;
      }
    }

    if (cont.querySelector('[data-variants-json]') == null) return;

    let activeVariants = [];
    let priceBreakQuantities = [1];
    let quantities = [];

    // prep quantities for the price breaks to build the table
    if (priceBreaks != null) {
      priceBreaks.forEach(qty => {
        if (!priceBreakQuantities.includes(qty) && typeof qty != "undefined") priceBreakQuantities.push(qty);
      });
    }

    // we have variants
    if (variants != null) {
      // get options
      let color = variants.querySelector('input[name="Color"]:checked').value;
      let sizesEls = variants.querySelectorAll('.b2b-sizes .product-form__swatch__item');

      if (variants.querySelector('.product-form__swatch__sub-title.js-option-title')) {
        variants.querySelector('.product-form__swatch__sub-title.js-option-title').innerText = color;
      }

      // get active sizes
      let sizes = {};
      sizesEls.forEach(el => {
        if (el.querySelector('input').value.length > 0 && el.dataset.value != 'QTY') {
          let val = parseInt(el.querySelector('input').value);
          sizes[el.dataset.value] = val;

          // gather all required quantities to get prices later
          if (typeof val != "undefined") quantities.push(val);
        }
      });

      // remove 0 from required quantity
      let zeroIndex = quantities.indexOf(0);
      if (zeroIndex > -1) {
        quantities.splice(zeroIndex, 1);
      }

      // get active variant IDs ant quantities
      activeVariants = _this.getActiveVariants(sizes, randomSample);
    }
    // we just have the single quantity field
    else if (cont.querySelector('input[name="quantity"]') != null) {
      let varId = parseInt(cont.querySelector('input[name="quantity"]').dataset.variantId);
      let price = parseFloat(cont.querySelector('input[name="quantity"]').dataset.price);
      let size = cont.querySelector('input[name="quantity"]').dataset.size;
      let val = cont.querySelector('input[name="quantity"]').value.length > 0 ? cont.querySelector('input[name="quantity"]').value : 1;
      activeVariants = [
        {
          'id': varId,
          'price': price,
          'quantity': val,
          'size': size
        }
      ];
    }

    quantities.forEach(qty => {
      totalQty += qty;
    });

    let targetPriceBreak = null;
    // if total qty is not between already known price breaks get the price for it
    for (let i = 0; i < priceBreaks.length; i++) {
      if (i < 1 && totalQty < priceBreaks[i]) {
        targetPriceBreak = priceBreaks[i]
      } else if (totalQty >= priceBreaks[i] && totalQty < priceBreaks[i + 1]) {
        targetPriceBreak = priceBreaks[i]
      } else if (totalQty > priceBreaks[i]) {
        targetPriceBreak = priceBreaks[i]
      }
    }

    if (typeof activeVariants != "undefined" && activeVariants.length > 0 && totalQty > 0) {
      if (randomSample && _this.randomSamplePrices != null) {
        _this.getrandomSamplePrices(sampleProductId, totalQty, _this.calculateTotal.bind(_this));
        return;
      }
    }

    if (_this.gettingOptionsPrices > 0) {
      setTimeout(function () {
        _this.calculateTotal.bind(_this)();
      }, 500);
      return;
    } else {
      if (typeof decorationId != "undefined" && decorationId && totalQty > 0 && (!_this.optionsPrices.hasOwnProperty(decorationId) || !_this.optionsPrices[decorationId].hasOwnProperty(totalQty))) {
        _this.getOptionsPrices(decorationId, totalQty, _this.calculateTotal.bind(_this));
        return;
      }
    }

    if (!randomSample) {
      // if we're not getting any prices in the background at this moment,
      // check if we need to get them or if we have what we need to update the totals
      if (_this.gettingPrices === 0) {

        // if we don't have variants we just use the single quantity field
        let testValue = 1;
        if (cont.querySelector('input[name="quantity"]') != null && cont.querySelector('input[name="quantity"]').value.length > 0) {
          testValue = parseInt(cont.querySelector('input[name="quantity"]').value);
          quantities = [];
          quantities.push(testValue);
        }

        // check if we already have all prices that we need
        let hasAllPrices = true;
        priceBreakQuantities.forEach(qty => {
          if (!_this.b2bPrices.hasOwnProperty(qty)) {
            hasAllPrices = false;
          }
        });

        // if we're done with getting prices update the totals
        if (hasAllPrices) {
          _this.updatePriceRange();
          _this.updateTotal(activeVariants, randomSample);
        }
        // if we don't have the prices yet, get them
        else {
          priceBreakQuantities.forEach(function (qty) {
            if (!_this.b2bPrices.hasOwnProperty(qty)) {
              _this.getB2BPrices(productId, qty, _this.calculateTotal.bind(_this));
            }
          });
        }
      }
        // if we're currently getting prices in the background,
      // set a timer and try again
      else {
        setTimeout(function () {
          _this.calculateTotal.bind(_this)();
        }, 500);
      }
    } else {
      // if we're not getting any prices in the background at this moment,
      // check if we need to get them or if we have what we need to update the totals
      if (_this.gettingRandomSamplePrices === 0) {

        // if we don't have variants we just use the single quantity field
        let testValue = 1;
        if (cont.querySelector('input[name="quantity"]') != null && cont.querySelector('input[name="quantity"]').value.length > 0) {
          testValue = parseInt(cont.querySelector('input[name="quantity"]').value);
          quantities = [];
          quantities.push(testValue);
        }

        // check if we already have all prices that we need
        let hasAllPrices = true;
        quantities.forEach(qty => {
          if (!_this.randomSamplePrices.hasOwnProperty(qty)) {
            hasAllPrices = false;
          }
        });

        // if we're done with getting prices update the totals
        if (cont.querySelector('input[name="quantity"]') == null && hasAllPrices ||
          (cont.querySelector('input[name="quantity"]') != null && _this.randomSamplePrices.hasOwnProperty(testValue))) {
          _this.updateTotal(activeVariants, randomSample);
        }
        // if we don't have the prices yet, get them
        else {
          quantities.forEach(function (qty) {
            if (!_this.randomSamplePrices.hasOwnProperty(qty)) {
              _this.getrandomSamplePrices(sampleProductId, qty, _this.calculateTotal.bind(_this));
            }
          });
          setTimeout(function () {
            _this.calculateTotal.bind(_this)();
          }, 500);
        }
      }
        // if we're currently getting prices in the background,
      // set a timer and try again
      else {
        setTimeout(function () {
          _this.calculateTotal.bind(_this)();
        }, 500);
      }
    }

  }
  ,

  updateTotal: function (activeVariants, randomSample) {
    let _this = this;
    let cont = document.querySelector('.js-product-single-actions');
    let el = cont.querySelectorAll('.b2b-totals .total .value');
    let elEach = cont.querySelectorAll('.b2b-totals .each .value');
    let topTotals = cont.querySelector('.b2b-prices .b2b-totals');
    let priceRange = cont.querySelector('.b2b-prices .price-range');
    let priceBreaks = JSON.parse(cont.querySelector('[data-price-breaks]').dataset.priceBreaks);
    if (cont == null) return;
    let decorationOptionSelect = cont.querySelector('.decoration-option select');
    let decorationProdId = null;
    let decorationVarId = null;
    let decorationOriginalPrice = 0;
    let total = 0;
    let totalEach = 0;
    let totalQty = 0;
    let decorationOption = 0;
    let pricesObj = randomSample ? this.randomSamplePrices : this.b2bPrices;
    let decoration = null;

    activeVariants.forEach(variant => {
      totalQty += variant.quantity;
    });

    let targetPriceBreak = null;
    // if total qty is not between already known price breaks get the price for it
    for (let i = 0; i < priceBreaks.length; i++) {
      if (i < 1 && totalQty < priceBreaks[i]) {
        targetPriceBreak = priceBreaks[i]
      } else if (totalQty >= priceBreaks[i] && totalQty < priceBreaks[i + 1]) {
        targetPriceBreak = priceBreaks[i]
      } else if (totalQty >= priceBreaks[i]) {
        targetPriceBreak = priceBreaks[i]
      }
    }

    if (document.querySelector('.decoration-option select') != null) {
      decoration = decorationOptionSelect.options[decorationOptionSelect.selectedIndex];
    }
    //if (decoration.value.length < 1) return true;v
    if (decoration && decoration.value.length > 0) {
      let handle = decoration.dataset.handle;
      let imprintColorsName = cont.querySelector('.imprint-colors [data-handle="' + handle + '"] input').getAttribute('name');

      if (decorationOptionSelect != null) {
        decorationProdId = decorationOptionSelect.options[decorationOptionSelect.selectedIndex].dataset.productId;
        //decorationOriginalPrice = decorationOptionSelect.options[decorationOptionSelect.selectedIndex].dataset.originalPrice;
      }
      //decorationOriginalPrice = cont.querySelector('[data-handle="' + handle + '"] [name="' + imprintColorsName + '"]:checked').dataset.originalPrice;
      if (cont.querySelector('[data-handle="' + handle + '"] [name="' + imprintColorsName + '"]:checked')) {
        let _decorationVarId = cont.querySelector('[data-handle="' + handle + '"] [name="' + imprintColorsName + '"]:checked').value;
        decorationVarId = _decorationVarId.split('|')[1].replace(' ', '');
      }
    }
    let savingsEl = cont.querySelector('.b2b-totals .savings .value');

    if (typeof activeVariants != "undefined" && activeVariants.length > 0) {
      let priceUpdated = false;
      if (pricesObj != null) {
        activeVariants.forEach(variant => {
          if (typeof pricesObj[targetPriceBreak] != "undefined") {
            let p = pricesObj[targetPriceBreak].variants[variant.id].amount;
            if (p.includes('.')) {
              p = parseFloat(p);
            } else {
              p = parseFloat(p);
            }
            totalEach = p * 100;
            total += p * 100 * variant.quantity;
            priceUpdated = true;
          }
        });
      }

      if (!priceUpdated) {
        activeVariants.forEach(variant => {
          totalEach = variant.price;
          total += variant.price * variant.quantity;
        });
      }

    }

    _this.total = (total / 100).toFixed(2);
    _this.totalEach = (totalEach / 100).toFixed(2);

    if (_this.gettingOptionsPrices > 0 || _this.gettingPrices > 0 || (randomSample && _this.gettingRandomSamplePrices > 0)) {
      setTimeout(function () {
        _this.updateTotal(activeVariants, randomSample);
      }, 100);
      return;
    }

    if (typeof decorationProdId != "undefined" && decorationVarId && decorationVarId.length > 0) {
      if (typeof decorationProdId != "undefined" &&
        decorationVarId.length > 0 && totalQty > 0 &&
        typeof _this.optionsPrices[decorationProdId] != "undefined" &&
        typeof _this.optionsPrices[decorationProdId][totalQty] != "undefined"
      ) {
        decorationOption = _this.optionsPrices[decorationProdId][totalQty].variants[decorationVarId].amount * 100;
      }

      if (typeof decorationOption != "undefined") total += decorationOption * totalQty;
    }

    totalEach = (total / totalQty / 100).toFixed(2);
    total = (total / 100).toFixed(2);

    if (isNaN(totalEach)) totalEach = 0.00;
    if (isNaN(total)) total = 0.00;

    _this.totalWithDecoration = total;

    if (total > 0) {
      topTotals.classList.remove('hidden');
      priceRange.classList.add('hidden');
    } else {
      topTotals.classList.add('hidden');
      priceRange.classList.remove('hidden');
    }

    el.forEach(_el => {
      _el.textContent = '$' + total;
    });
    elEach.forEach(_elEach => {
      _elEach.textContent = '$' + totalEach;
    });

    let qtySumField = cont.querySelector('.qty-sum-field');
    qtySumField.value = totalQty;

    let totalBasePrice = 0;
    let totalB2BPrice = 0;

    // calculate and update savings
    if (typeof activeVariants != "undefined" && activeVariants.length > 0) {
      let savings = 0;
      activeVariants.forEach(variant => {
        let basePrice = parseFloat(variant.original_price);
        totalBasePrice += basePrice;

        //if (isNaN(basePrice)) basePrice = parseInt(variant.price);
        let b2bPrice = parseFloat(pricesObj[targetPriceBreak].variants[variant.id].amount) * 100;
        totalB2BPrice += b2bPrice;
      });

      savings = totalBasePrice - totalB2BPrice;

      if (savings > 0 && savingsEl != null) {
        savingsEl.innerText = '$' + (savings / 100).toFixed(2);
        savingsEl.closest('.savings').classList.remove('hidden');
      } else if (savingsEl != null) {
        savingsEl.closest('.savings').classList.add('hidden');
      }
    } else {
      savingsEl.closest('.savings').classList.add('hidden');
    }
  }
  ,

  updatePriceRange: function () {
    let _this = this;
    let minPrice = 0;
    let maxPrice = 0;
    let price = 0;
    let priceString = '';
    let minEl = document.querySelector('.b2b-prices .price-range .min');
    let maxEl = document.querySelector('.b2b-prices .price-range .max');

    let pricesObj = _this.listPrices;
    if (typeof _this.b2bPrices[1] != "undefined") {
      pricesObj = _this.b2bPrices;
      if (pricesObj) {
        for (const [_key, _value] of Object.entries(pricesObj)) {
          for (const [key, value] of Object.entries(_value.variants)) {
            price = parseFloat(value.amount).toFixed(2);
            priceString = '$' + price;
            if (minPrice == 0 || parseFloat(value.amount) < minPrice) {
              minPrice = parseFloat(value.amount);
            }
            if (maxPrice == 0 || parseFloat(value.amount) > maxPrice) {
              maxPrice = parseFloat(value.amount);
            }
          }
        }

        if (minEl && parseFloat(minEl.dataset.min) != minPrice) {
          minEl.innerText = '$' + minPrice.toFixed(2);
        }

        if (maxEl && parseFloat(maxEl.dataset.max) != maxPrice) {
          maxEl.innerText = '$' + maxPrice.toFixed(2);
        }
      }

    } else {
      if (pricesObj) {
        pricesObj.forEach(_price => {
          price = parseFloat(_price).toFixed(2);
          priceString = '$' + price;
          if (minPrice == 0 || parseFloat(_price) < minPrice) {
            minPrice = parseFloat(_price);
          }
          if (maxPrice == 0 || parseFloat(_price) > maxPrice) {
            maxPrice = parseFloat(_price);
          }
        });

        if (minEl && parseFloat(minEl.dataset.min) != minPrice) {
          minEl.innerText = '$' + minPrice.toFixed(2);
        }

        if (maxEl && parseFloat(maxEl.dataset.max) != maxPrice) {
          maxEl.innerText = '$' + maxPrice.toFixed(2);
        }
      }
    }
  },

  updateSamplePrices: function () {
    let _this = this;
    let price = 0;
    let priceString = '';
    let form = document.querySelector('.js-product-single-actions form');
    let minPrice = 0;
    let maxPrice = 0;

    if (_this.randomSamplePrices != null) {
      for (const [key, value] of Object.entries(_this.randomSamplePrices[1].variants)) {
        price = parseFloat(value.amount).toFixed(2);
        priceString = '$' + price;
        if (minPrice == 0 || parseFloat(value.amount) < (minPrice / 100)) {
          minPrice = parseFloat(value.amount);
        }
        if (maxPrice == 0 || parseFloat(value.amount) > (maxPrice / 100)) {
          maxPrice = parseFloat(value.amount);
        }
      }
    }

    let checkboxEl = form.querySelector('input[name="sample-product"]');
    if (checkboxEl) {
      let checkboxPrice = checkboxEl.closest('label').querySelector('.price');
      checkboxPrice.innerText = priceString;
    }

    if (form.querySelector('[name="sample-product"]').checked) {
      let each = document.querySelectorAll('.b2b-totals .each .value');
      let total = document.querySelectorAll('.b2b-totals .total .value');
      each.forEach(el => {
        el.innerText = priceString;
      })
      /*total.forEach(el => {
        el.innerText = priceString;
      });*/
      _this.updateTotal(_this.activeVariants, true);

      document.querySelector('.b2b-prices .price-range').classList.add('hidden');
      document.querySelector('.b2b-prices .b2b-totals').classList.remove('hidden');
    } else {
      document.querySelector('.b2b-prices .price-range').classList.remove('hidden');
      document.querySelector('.b2b-prices .b2b-totals').classList.add('hidden');
      _this.updateTotal();
    }
  }
  ,

  addSampleProductToCart: function (id) {
    let _this = this;

    // get options
    let cont = document.querySelector('.js-product-single-actions');
    let variants = cont.querySelector('product-interactive-options');
    let activeVariants = [];

    if (variants != null) {
      activeVariants = this.getActiveVariants(false, true);
    } else if (cont.querySelector('input[name="quantity"]') != null) {
      let varId = parseInt(cont.querySelector('input[name="quantity"]').dataset.variantId);
      let price = parseFloat(cont.querySelector('input[name="quantity"]').dataset.price);
      let size = cont.querySelector('input[name="quantity"]').dataset.size;
      let val = cont.querySelector('input[name="quantity"]').value.length > 0 ? cont.querySelector('input[name="quantity"]').value : 1;
      activeVariants = [
        {
          'id': varId,
          'price': price,
          'quantity': val,
          'size': size
        }
      ];
    }

    let data = {
      'items': []
    }

    activeVariants.forEach(variant => {
      let obj = {
        'id': variant.id,
        'quantity': variant.quantity,
      }

      data.items.push(obj);
    });

    $.ajax('/cart/add.js', {
      contentType: 'application/json',
      type: 'POST',
      data: JSON.stringify(data),
      dataType: 'json',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Accept', 'application/json');

      },
      success: function (data) {
        _this.openCartDrawer();

      },
      error: function (xhr, status, error) {

      }
    });

  }
  ,

  openCartDrawer: function () {
    window.ajaxCart.load();
    $('.secondary-nav__link.js-cart-trigger').click();
  }
  ,

  validateForm: function (form) {
    let formData = new FormData(form);
    let valid = true;

    let decoration = null;
    if (document.querySelector('.decoration-option select') != null) {
      let selectEl = document.querySelector('.decoration-option select');
      decoration = selectEl.options[selectEl.selectedIndex];
    }

    let decorationOptionEl = form.querySelector('.decoration-option');
    let uploadDefaultArtworkEl = form.querySelector('.upload-artwork.default-decoration');
    let uploadArtworkEl = form.querySelector('.upload-artwork.additional-decorations');

    let sizesEls = form.querySelectorAll('.b2b-sizes .product-form__swatch__item');
    let sizes = 0;
    sizesEls.forEach(el => {
      if (!el.querySelector('input').classList.contains('qty-sum-field') && el.querySelector('input').value.length > 0) {
        sizes++;
      }
    });

    if (sizes < 1) {
      valid = false;
      form.querySelector('.b2b-sizes').classList.add('error');
      form.querySelector('.b2b-error.size').classList.remove('hidden');
    } else {
      form.querySelector('.b2b-sizes').classList.remove('error')
      form.querySelector('.b2b-error.size').classList.add('hidden');
    }

    if (decoration && decoration.value.length < 1) {
      if (uploadDefaultArtworkEl != null) {
        uploadDefaultArtworkEl.classList.remove('error');
        if (uploadDefaultArtworkEl.querySelector('select').value === 'Upload' && uploadDefaultArtworkEl.querySelector('input').files.length < 1) {
          valid = false;
          uploadDefaultArtworkEl.classList.add('error');
          uploadDefaultArtworkEl.querySelector('.upload-field').classList.add('error');
          form.querySelector('.b2b-error.default-artwork').classList.remove('hidden');
        } else {
          uploadDefaultArtworkEl.querySelector('.upload-field').classList.remove('error');
          form.querySelector('.b2b-error.default-artwork').classList.add('hidden');
        }
        return valid;
      } else return true;
    }
    let handle = decoration ? decoration.dataset.handle : null;

    if (document.querySelector('.b2b-product-customization') != null) {
      let decorationOption = formData.get('properties[Decoration Option]');
      if (decorationOption && decorationOption.length < 1) {
        valid = false;
        decorationOptionEl.classList.add('error');
        form.querySelector('.b2b-error.decoration-option').classList.remove('hidden');
      } else {
        decorationOptionEl.classList.remove('error');
        form.querySelector('.b2b-error.decoration-option').classList.add('hidden');
      }

      if (uploadDefaultArtworkEl) {
        uploadDefaultArtworkEl.classList.remove('error');
        if (uploadDefaultArtworkEl.querySelector('select').value === 'Upload' && uploadDefaultArtworkEl.querySelector('input').files.length < 1) {
          valid = false;
          uploadDefaultArtworkEl.classList.add('error');
          uploadDefaultArtworkEl.querySelector('.upload-field').classList.add('error');
          form.querySelector('.b2b-error.default-artwork').classList.remove('hidden');
        } else {
          uploadDefaultArtworkEl.querySelector('.upload-field').classList.remove('error');
          form.querySelector('.b2b-error.default-artwork').classList.add('hidden');
        }
      }

      let decorationLocations = formData.getAll('properties[Decoration locations]');
      if (form.querySelector('.decoration-locations')) {
        if (decorationLocations && decorationLocations.length < 1) {
          valid = false;
          form.querySelector('.decoration-locations').classList.add('error');
          form.querySelector('.b2b-error.decoration-location').classList.remove('hidden');
        } else {
          form.querySelector('.decoration-locations').classList.remove('error');
          form.querySelector('.b2b-error.decoration-location').classList.add('hidden');

          decorationLocations.forEach(loc => {

            if (uploadArtworkEl.querySelector('select').value === 'Upload' && !uploadArtworkEl.classList.contains('hidden')) {
              uploadArtworkEl.classList.remove('error');
              if (form.querySelector('.upload-field[data-location="' + loc + '"] input').files.length < 1) {
                valid = false;
                uploadArtworkEl.classList.add('error');
                form.querySelector('.upload-field[data-location="' + loc + '"]').classList.add('error');
                form.querySelector('.b2b-error.artwork').classList.remove('hidden');
              } else {
                form.querySelector('.upload-field[data-location="' + loc + '"]').classList.remove('error');
                form.querySelector('.b2b-error.artwork').classList.add('hidden');
              }
            } else {
              uploadArtworkEl.classList.remove('error');
              form.querySelector('.upload-field[data-location="' + loc + '"]').classList.remove('error');
              form.querySelector('.b2b-error.artwork').classList.add('hidden');
            }
          });
        }
      }
    }
    return valid;
  }
  ,

  getActiveVariants: function (sizes = false, randomSample = false) {
    if (!sizes) {
      let cont = document.querySelector('.js-product-single-actions');
      let variants = cont.querySelector('product-interactive-options');

      // get options
      let sizesEls = variants.querySelectorAll('.b2b-sizes .product-form__swatch__item');
      if (cont.querySelector('[data-variants-json]') == null) return;

      // get active sizes
      sizes = {};
      sizesEls.forEach(el => {
        if (el.querySelector('input').value.length > 0) {
          sizes[el.dataset.value] = parseInt(el.querySelector('input').value);
        }
      });
    }

    let variants = [];

    // get correct color and size indexes
    let colorIndex = 1;
    let sizeIndex = 2;

    this.productOptions.forEach((option, index) => {
      if (option.toLowerCase() === 'color') {
        colorIndex = index + 1;
      } else if (option.toLowerCase() === 'size') {
        sizeIndex = index + 1;
      }
    });

    let colorIndexString = 'option' + colorIndex;
    let sizeIndexString = 'option' + sizeIndex;

    let object = randomSample ? this.sampleVariantsJSON : this.variantsJSON;

    // extract variant IDs and append quantities
    object.forEach(variant => {
      // if variant has the color that we need
      if (variant[colorIndexString] === this.currentColor) {

        //if variant has the size that we need
        if (sizes.hasOwnProperty(variant[sizeIndexString])) {
          variants.push({
            'id': variant.id,
            'price': variant.price,
            'original_price': variant.original_price,
            'quantity': sizes[variant[sizeIndexString]],
            'size': variant[sizeIndexString]
          });
        }
      }
    });

    this.activeVariants = variants;
    return variants;
  }
  ,

  upload: function (file, index, name) {
    let _this = this;
    _this.uploading++;

    let formData = new FormData();
    formData.append('file', file);

    $.ajax(_this.api.url_upload, {
      type: 'POST',
      data: formData,
      contentType: false,
      processData: false,
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', `Bearer ${_this.api.token}`);
        xhr.setRequestHeader('Accept', 'application/json');
      },
      success: function (data) {
        _this.uploading--;
        _this.tries = 0;
        if (_this.uploading < 0) _this.uploading = 0;
        _this.files.push({
          'url': data.url,
          'name': name
        })
      },
      error: function (xhr, status, error) {
        _this.uploading--;
        if (_this.uploading < 0) _this.uploading = 0;

        if (_this.tries >= _this.api.maxTries) {
          _this.running = false;
          throw error;
        }

        if (xhr.status !== 401) {
          _this.running = false;
          throw error;
        } else _this.getJWTToken(_this.upload(file, index, name));

      }
    });
  }
  ,

  submitDraftOrder: function (_data, btn) {
    let _this = this;

    let data = {};

    data['shipping_address'] = JSON.parse(btn.dataset.customerAddress);
    data['customer_id'] = JSON.parse(btn.dataset.customerId);
    data.line_items = [];

    _data.items.forEach(item => {

      let files = item.properties['_files'];
      let newFiles = {};

      if (typeof files != "undefined") {
        for (const [key, value] of Object.entries(files)) {
          let _key = key.replace('properties[Artwork - ', '').replace(']', '');
          newFiles[_key] = value;
        }
      }

      let obj = {
        'variant_id': item.id,
        'quantity': item.quantity,
        'files': newFiles,
        'properties': item.properties
      };

      data.line_items.push(obj);
    });

    let atc = document.querySelector('.b2b-product-add .js-product-add-text');
    let errorCont = atc == null ? null : atc.closest('form').querySelector('.b2b-error.response');
    /*
    atc.innerText = atc.dataset.addingToCart;
    atc.closest('.b2b-product-add').setAttribute('disabled', 'disabled');*/

    $.ajax(_this.api.url_draft_orders, {
      contentType: 'application/json',
      type: 'POST',
      data: JSON.stringify(data),
      dataType: 'json',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', `Bearer ${_this.api.token}`);
        xhr.setRequestHeader('Accept', 'application/json');

        //_this.tries = 1;
      },
      success: function (_data) {
        if (typeof _data.checkout_url != "undefined") {
          location.href = _data.checkout_url;
        }
        _this.running = false;
        _this.tries = 0;
      },
      error: function (xhr, status, error) {
        //atc.innerText = atc.dataset.addToCart;
        //atc.closest('.b2b-product-add').removeAttribute('disabled');
        if (_this.tries >= _this.api.maxTries) {
          _this.running = false;
          throw error;
        }

        if (xhr.status === 422) {
          _this.running = false;

          if (typeof xhr.responseJSON.errors != "undefined") {

            if (errorCont != null) errorCont.innerText = '';
            for (const [key, value] of Object.entries(xhr.responseJSON.errors)) {
              let val = value[0].replace('address.', 'address - ')
                .replace('The shipping', 'The "shipping')
                .replace(' field', '" field');
              if (key == 'line_items') {
                val = 'Please select a size.'
              }
              let el = document.createElement('div');
              el.classList.add('error-item');
              el.innerText = val;
              if (errorCont != null) errorCont.appendChild(el);
            }
            if (errorCont != null) errorCont.classList.remove('hidden');
          }

          throw error;
        }

        if (xhr.status !== 401) {
          _this.running = false;
          throw error;
        } else _this.getJWTToken(_this.submitDraftOrder(btn));

      }
    });
  }
  ,

  getJWTToken: function (callback) {
    let _this = this;
    // This is the custom page that should generate the token
    $.ajax('/pages/jwt-token-page')
      .done(token => {
        _this.api.token = token.trim();
        _this.tries += 1;
        if (typeof callback == 'function') {
          return callback();
        }
      });
  }

}

B2BStorefront.init();
getBrowserName();